import { render, staticRenderFns } from "./ContentViewSettingsPlugins.vue?vue&type=template&id=99512942&scoped=true&"
import script from "./ContentViewSettingsPlugins.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsPlugins.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsPlugins.vue?vue&type=style&index=0&id=99512942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99512942",
  null
  
)

export default component.exports